var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18C18.3284 18 19 18.6716 19 19.5C19 20.3284 18.3284 21 17.5 21C16.6716 21 16 20.3284 16 19.5C16 18.6716 16.6715 18 17.5 18Z",
    fill: "#535E70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11C18.3284 11 19 11.6715 19 12.5C19 13.3284 18.3284 14 17.5 14C16.6716 14 16 13.3284 16 12.5C16 11.6716 16.6715 11 17.5 11Z",
    fill: "#535E70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 4C18.3284 4 19 4.67155 19 5.5C19 6.32845 18.3284 7 17.5 7C16.6716 7 16 6.32845 16 5.5C16 4.67155 16.6715 4 17.5 4Z",
    fill: "#535E70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionImg);
export default __webpack_public_path__ + "static/media/action-img.e1ea95f8f3e4c884d5366e102f2dbccd.svg";
export { ForwardRef as ReactComponent };